import {Box, Divider, IconButton, Popover} from '@mui/material';
import AppsIcon from '@mui/icons-material/Apps';
import {useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {NavigationCard} from './NavigationCard';
import {additionalNavigationCards, appNavigationCards} from './constants';
import {usePermissions} from 'utils/hooks/permissions/usePermissions';

export const AppNavigation = () => {
    const {t} = useTranslation('common');
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const {roles} = usePermissions();

    const filteredAppCards = useMemo(
        () => appNavigationCards.filter((card) => roles?.includes(card.permission)),
        [roles],
    );

    const filteredAdditionalCards = useMemo(
        () => additionalNavigationCards.filter((card) => roles?.includes(card.permission)),
        [roles],
    );

    return (
        <>
            <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
                <AppsIcon />
            </IconButton>
            <Popover
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                elevation={0}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: '16px',
                            border: '8px solid rgba(255, 255, 255, 0.01)',
                            boxShadow:
                                '0px 4px 16px rgba(0, 0, 0, 0.24), 0px 2px 4px rgba(0, 0, 0, 0.12)',
                        },
                    },
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: '8px',
                        padding: '8px',
                    }}
                >
                    {filteredAppCards.map((card) => (
                        <NavigationCard
                            key={card.titleKey}
                            title={t(card.titleKey)}
                            icon={card.icon}
                            route={card.route}
                            color={card.color}
                            closeAppNavigation={() => setAnchorEl(null)}
                        />
                    ))}
                    {filteredAdditionalCards.length > 0 && (
                        <Divider
                            sx={{
                                gridColumn: 'span 3',
                                borderColor: 'var(--mui-palette-divider)',
                                borderBottomWidth: '2px',
                            }}
                        />
                    )}
                    {filteredAdditionalCards.map((card) => (
                        <NavigationCard
                            key={card.titleKey}
                            title={t(card.titleKey)}
                            icon={card.icon}
                            route={card.route}
                            color={card.color}
                            gradient={card.gradient}
                            closeAppNavigation={() => setAnchorEl(null)}
                        />
                    ))}
                </Box>
            </Popover>
        </>
    );
};
